import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsRegions from "../generic-nav-bar/NavbarIconsRegions";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import SearchBackRegion from "../generic-search/SearchBackRegion";
import { useTranslation } from "react-i18next";
import { useTracking } from "react-tracking";
import { startLoadingContinents } from "../../app/actions/catalogContinentActions";
import { cleanSearchingRegionsPaginated, regionCleanSearchText, regionStartDelete, selectRegions, startLoadingRegionsPaginated, startSearchingRegionsPaginated } from "../../app/actions/catalogRegionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import TableRegions from "./TableRegions";

const ID_FORM = "admin-region";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListRegions = () => {
  debugLogPages(':: ListRegions');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogRegionsS, catalogRegionsP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogRegion);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");


  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingRegionsPaginated());
    dispatch(regionCleanSearchText());
    //Load Data
    dispatch(startLoadingRegionsPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingContinents());
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditRegions", method: "onEditRow", event: "EditRegions-Clicked" });

    dispatch(selectRegions(row));
    if (catalogRegionsS?.length > 0) {
      navigate("/admin-region/edit-region", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-region/edit-region");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteRegions", method: "onDeleteRow", event: "DeleteRegions-Clicked" });
    dispatch(regionStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (catalogRegionsS && catalogRegionsS.length > 0) {
      dispatch(startSearchingRegionsPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingRegionsPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogRegionsS && catalogRegionsS.length > 0) {
      dispatch(startSearchingRegionsPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingRegionsPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsRegions page={"listRegions"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackRegion searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogRegionsS && catalogRegionsS.length > 0 ? (
        <TableRegions data={catalogRegionsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableRegions data={catalogRegionsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogRegionsS && catalogRegionsS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListRegions;
